import React from 'react';
import PropTypes from 'prop-types';
import BusinessAnalytics from '../../../assets/icons/navigation/business_analytics.svg';
import Forecast from '../../../assets/icons/navigation/forecast.svg';
import OfferPerformance from '../../../assets/icons/navigation/offer_performance.svg';
import Bookings from '../../../assets/icons/navigation/bookings.svg';
import ManageOffers from '../../../assets/icons/navigation/manage_offers.svg';
import AudiencesNetworks from '../../../assets/icons/navigation/audiences_networks.svg';
import DatabaseBuilder from '../../../assets/icons/navigation/database_builder.svg';
import Transactions from '../../../assets/icons/navigation/transactions.svg';
import BillingSettlement from '../../../assets/icons/navigation/billing_settlement.svg';
import Menus from '../../../assets/icons/navigation/menus.svg';
import Integrations from '../../../assets/icons/navigation/integrations.svg';
import Partners from '../../../assets/icons/navigation/partners.svg';
import HelpCentre from '../../../assets/icons/navigation/help_center.svg';

/**
 * 16×16 nav icons (SVGR) keyed by `navigationItems[].id` from AppLayout.
 * Create offer is a text button and has no list icon.
 */
const BY_ID = {
  'business-analytics': BusinessAnalytics,
  forecast: Forecast,
  'offer-performance': OfferPerformance,
  bookings: Bookings,
  'manage-offers': ManageOffers,
  'audience-targeting': AudiencesNetworks,
  'guest-manager': DatabaseBuilder,
  /** Staff: reuse manage-offers visual until a dedicated asset exists */
  tags: ManageOffers,
  transactions: Transactions,
  'billing-and-settlement': BillingSettlement,
  menus: Menus,
  integrations: Integrations,
  partners: Partners,
  'help-centre': HelpCentre,
  /** Goals-off legacy row */
  deals: ManageOffers,
};

export const NavigationItemIcon = ({ id }) => {
  const Cmp = BY_ID[id];
  if (!Cmp) {
    return null;
  }
  return <Cmp aria-hidden focusable='false' />;
};

NavigationItemIcon.propTypes = {
  id: PropTypes.string.isRequired,
};
